import React from 'react';

export const PitchText = ({text}) => {
  text = text.replace(/_/g, '&flat;');

  return (
    <React.Fragment>
      {text}
    </React.Fragment>
  )
};